module.exports = __webpack_public_path__ + "img/servicios-slider-bg.6cc80db8.jpg";